module.exports = __webpack_public_path__ + "static/media/IMG_6456.f9b8c47e.JPG";